export const getEmbroideryConfigKeyAndAsset = ({
  configs,
  productCategoryIdList,
}) => {
  if (!configs) {
    return null;
  }
  for (const [key, assetConfig] of Object.entries(configs.assets)) {
    if (key === 'default') {
      continue;
    }
    const categories = configs.categories[key];
    if (
      categories?.some((category) => productCategoryIdList?.includes(category))
    ) {
      return {
        embroideryConfigKey: key,
        embroideryAssetConfig: assetConfig,
      };
    }
  }
  return {
    embroideryConfigKey: 'default',
    embroideryAssetConfig: configs.assets.default,
  };
};
